import { LogOut } from 'lucide-react';
import React from 'react';
import { Button } from '../core/components/Button';
import { ThemeToggle } from '../core/components/ThemeToggle';
import { NotificationBell } from '../core/notifications/NotificationBell';
import './AppHeader.css';

export type AppScreen = 'users' | 'sync' | 'stats' | 'support';

const NAV_ITEMS: { id: AppScreen; label: string }[] = [
    { id: 'users',   label: 'Пользователи' },
    { id: 'sync',    label: 'Синхронизация' },
    { id: 'stats',   label: 'Статистика' },
    { id: 'support', label: 'Поддержка' },
];

interface AppHeaderProps {
    activeScreen: AppScreen;
    onNavigate: (screen: AppScreen) => void;
    onLogout: () => void;
}

export const AppHeader: React.FC<AppHeaderProps> = ({ activeScreen, onNavigate, onLogout }) => (
    <header className="home-header">
        <div className="header-logo">
            <span className="header-logo__accent">{'// '}</span>
            OGO<span className="header-logo__sep">_</span>SA
        </div>

        <nav className="nav-tabs">
            {NAV_ITEMS.map(({ id, label }) => (
                <button
                    key={id}
                    className={`nav-tab ${activeScreen === id ? 'nav-tab--active' : ''}`}
                    onClick={() => onNavigate(id)}
                >
                    {label}
                </button>
            ))}
        </nav>

        <div className="header-controls">
            <NotificationBell />
            <ThemeToggle />
            <Button variant="ghost" size="sm" icon={<LogOut size={14} />} onClick={onLogout}>
                Выйти
            </Button>
        </div>
    </header>
);
